(function () {
  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(0) + " Kč";
  }

  function getVariantsFromTextarea(root) {
    const el = root.querySelector("textarea[data-variant-json]");
    if (!el) return null;
    try {
      return JSON.parse(el.value || el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getVariantIdFromForm(root) {
    const form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? idInput.value : null;
  }

  function updateForRoot(root, forcedVariant) {
    const wrapper = root.querySelector("[data-price-in-cart-wrapper]");
    if (!wrapper) return;

    const discount = Number(wrapper.dataset.discountPercent || 30);
    const moneyFormat = wrapper.dataset.moneyFormat || "{{amount}} Kč";

    let variant = forcedVariant || null;

    if (!variant) {
      const variants = getVariantsFromTextarea(root);
      if (!variants) return;
      const variantId = getVariantIdFromForm(root);
      if (!variantId) return;
      variant = variants.find(v => String(v.id) === String(variantId)) || null;
    }

    if (!variant || typeof variant.price !== "number") return;

    const discounted = Math.round(variant.price * (100 - discount) / 100);
    const valueEl = wrapper.querySelector("[data-price-in-cart-value]");
    if (!valueEl) return;

    valueEl.textContent = formatMoney(discounted, moneyFormat);
  }

  function init() {
    const roots = document.querySelectorAll('[id^="ProductSection-"]');
    if (!roots.length) return;

    roots.forEach(root => {
      updateForRoot(root);

      root.addEventListener("change", function () {
        updateForRoot(root);
      });

      document.addEventListener("variant:change", function (e) {
        const v = e && e.detail && e.detail.variant ? e.detail.variant : null;
        updateForRoot(root, v);
      });
      document.addEventListener("variantChange", function (e) {
        const v = e && e.detail && e.detail.variant ? e.detail.variant : null;
        updateForRoot(root, v);
      });

      const form = root.querySelector('form[action*="/cart/add"]');
      if (form) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          const obs = new MutationObserver(function () {
            updateForRoot(root);
          });
          obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
